export enum QuoteStreamingDataSource {
    Mdas = 'mdas',
    Watchmen = 'watchmen',
}

export type WatchmenQuoteStreamingResponse = {
    ts: number; // timestamp
    u: Record<
        string,
        {
            px: number; // last price
            bx: number; // bid price
            ax: number; // ask price
            az: number; // ask size
            bz: number; // bid size
            v: number; // volume
            ts: number; // timestamp
        }
    >;
};

export interface WatchmenQuoteStreamingRequest {
    action: 'sub' | 'unsub';
    symbols: string[];
    mic?: string;
}

export type MdasRequestType =
    | 'queryl1'
    | 'querybestquote'
    | 'queryoptionl1'
    | 'queryoptionchain'
    | 'querybond'
    | 'queryonbbol1'
    | 'queryonbbol2'
    | 'queryonbbotimesale'
    | 'queryonbbolasttrade';

export interface MdasQuoteStreamingRequest {
    type: MdasRequestType;
    symbol: string;
    date?: string; // YYYY-MM-DD format for option chain
    unsubscribe?: boolean;
}

export interface MdasLevel1Data {
    Symbol: string;
    BidPx: number;
    AskPx: number;
    BidSz: number;
    AskSz: number;
    LastPx: number;
    Volume: number;
    QuoteTime: string;
    TradeTime?: string;
    Change: number;
    ChangePercent: number;
    HighPx: number;
    LowPx: number;
    OpenPx: number;
    YestClosePx: number;
}

export interface MdasResponse<T = MdasLevel1Data> {
    Message: string;
    Data: T[];
    Type: MdasRequestType;
    Error: boolean;
}

export type MdasQuoteStreamingResponse = MdasResponse<MdasLevel1Data>;

/**
 * Normalized streaming quote data produced by QuoteStreamingHandler.
 * Unified across MDAS and Watchmen data sources.
 */
export interface QuoteStreamingData {
    symbol: string;
    lastPrice: number;
    bid: number;
    ask: number;
    askSize: number;
    bidSize: number;
    volume: number;
    change?: number;
    changePercent?: number;
    dayHigh?: number;
    dayLow?: number;
    openingPrice?: number;
    yesterdayClose?: number;
}

export interface OrderStreamingResponse {
    eventId: number;
    type: 'Fill' | 'Accept' | 'Cancelled' | 'Rejected';
    mpid: string;
    accountNumber: string;
    symbol: string;
    ourRef: string;
    legRef: number;
    timestamp: string; // Format: 'MM/dd/yyyy HH:mm:ss z'
    transaction: 'BUY' | 'SELL' | string;
    lastPx: number;
    avgPx: number;
    lastShares: number;
    leavesQty: number;
    cumQty: number;
    option: boolean;
    bond: boolean;
    crypto: boolean;
    replay: boolean;
    branch: number;
}
